import styled from "styled-components"
import { theme } from "@omnichannel/ace-b2b-elements"

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0;
  width: 100%;
  padding: 3rem;
`

export const MainContainerHeader = styled.div`
  display: flex;
  width: 100%;
  font-size: 2.4rem;
  font-weight: 600;
  height: 3.2rem;
  margin: 0;
  align-items: center;
`

export const MainContainerMessage = styled.div`
  font-size: 1.5rem;
  color: ${theme.default.black80P};
`
